import { render, staticRenderFns } from "./ReportsPayroll.vue?vue&type=template&id=2bdce382&"
import script from "./ReportsPayroll.vue?vue&type=script&lang=js&"
export * from "./ReportsPayroll.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPayroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports